/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import { getRequest, postRequest, putRequest, exportRequest } from "../../helpers/Api";
import { types } from "../reducers/qrCodes";
import { userNotAuthorizedHandler } from "./authentication";

function* storeQrCode({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(payload.id ? putRequest : postRequest, {
      url: payload.id ? `/qr-code/${payload.id}` : "/qr-code",
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.qrCode),
    });

    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    if (res.status === 409) {
      const errorMessage =
        res.response && res.response.message
          ? res.response.message
          : res.message === "Conflict"
          ? "QR code is used already"
          : res.message;
      payload.onFailure(errorMessage, {
        errors: [
          {
            key: res.response && res.response.field ? res.response.field : "description",
            error: errorMessage,
          },
        ],
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({
        type: types.FETCH_QR_CODE_REQUEST,
        payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
      });
    } else {
      payload.onFailure(res.message);
    }
  } catch (err) {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }
}
/**
 * Fetch qrCodes when filters are changed
 */
function* fetchQrCodesRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.qrCodes);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(getRequest, {
    url: `/qr-code?${params.toString()}`,
    authorized: true,
  });

  if (response.status === 401) {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    const qrCodes = response.result.map((comp) => {
      if (comp.status) {
        comp.status = "1";
      } else {
        comp.status = "0";
      }
      return comp;
    });
    yield put({ type: types.ADD_QR_CODES, payload: { qrCodes } });
    yield put({
      type: types.SET_QR_CODE_TOTAL_ITEMS,
      payload: {
        totalItems: response.totalItems,
      },
    });
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
  } else {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    payload.onFailure(response.message || "Internal server error");
  }
}

function* exportQrCodeRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.punches);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(exportRequest, {
    url: `/export/qr-code?${params.toString()}`,
    authorized: true,
  });

  if (!response.status === 200) {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

/*
function* fetchLocationRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const response = yield call(getRequest, {
    url: `/locations`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_LOCATIONS, payload: { locations: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}
*/

export default function* sagas() {
  yield takeEvery(types.ADD_QR_CODE, storeQrCode);
  yield takeEvery(types.UPDATE_QR_CODE, storeQrCode);
  yield takeEvery(types.FETCH_QR_CODE_REQUEST, fetchQrCodesRequest);
  // yield takeEvery(types.FETCH_LOCATION_REQUEST, fetchLocationRequest);
  // yield takeEvery(types.FETCH_TIMEZONE_REQUEST, fetchTimezonesRequest);
  yield takeEvery(types.EXPORT_QR_CODE_REQUEST, exportQrCodeRequest);
}
